import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class Subscription extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "subscription";
    static pluralName = "subscriptions";
    static displayName = "Subscription";

    constructor() {
        super(Subscription.kind, Subscription.singularName, Subscription.pluralName);
    }

    async getAll(query = {}) {
        return this.fetch(qs.stringify(query, {encodeValuesOnly: true}));
    }


    async getById(id, query = {}) {
        return this.find(id, {populate: "*", ...query});
    }

    async getEntitlements(documentId) {
        return this.action({}, `/subscriptions/${documentId}/entitlements`);
    }

    async renew(documentId) {
        return this.postAction(`/subscriptions/${documentId}/renew`);
    }

    async changePlan(documentId, data) {
        return this.postAction(`/subscriptions/${documentId}/upgrade`, data);
    }

    async cancel(documentId, immediate = false) {
        return this.postAction(`/subscriptions/${documentId}/cancel`, {immediate});
    }
}
